import { Routes, Route } from 'react-router-dom';
import React from 'react';

import Dashboard from "../dashboard/Dashboard";
import Login from '../login/Login';
import ChangePassword from '../login/ChangePassword';
import Forgetpassword from '../forgot-password/Forgetpassword';
import Resetpassword from '../forgot-password/Resetpassword';
import User from '../user/User';
import UserDetails from '../user/UserDetails';
import College from '../college/College';
import CollegeDetails from '../college/CollegeDetails';
import Company from '../company/Company';
import CompanyDetails from '../company/CompanyDetails';
import IndustryType from '../industryType/IndustryType';
import IndustryTypeDetail from '../industryType/IndustryTypeDetail';
import Student from '../students/Student';
import StudentDetail from '../students/StudentDetail';
import EnrollIndustry from '../enroll-industry/enrollIndustry';
import EnrollAcademicInst from '../enroll-academic-inst/enrollAcademicInst';
import MyChallenges from '../myChallenges/MyChallenges';
import MyChallengesDetail from '../myChallenges/MyChallengesDetail';
import Challenges from '../challenges/Challenges';
import ChallengesDetail from '../challenges/ChallengesDetail';
import PrivateRoutes from '../../utils/PrivateRoutes';
import GrovatroLab from '../grovatorLab/GrovatorLab';
import GrovatroLabDetail from '../grovatorLab/GrovatorLabDetail';
import BusinessChallenges from '../businessChallenges/BusinessChallenges';
import GroupByCompany from '../reports/GroupByCompany';
import GroupByCollege from '../reports/GroupByCollege';
import GroupByChallenge from '../reports/GroupByChallenge';
import WinnerAnnouncement from '../winnerAnnouncement/Winner';
import Notification from '../notification/Notification';
import Terms from '../login/Terms';
import NewEnrollUser from '../newEnrollUser/NewEnrollUser';
import NewEnrollUserDetail from '../newEnrollUser/NewEnrollUserDetails';
import WinnerView from '../winnerAnnouncement/WinnerView';
import HackathonHome from '../hackathon/home';
import configData from '../../config.json';
import HackathonRoutes from '../../utils/HackathonRoutes';
import HackathonSchool from '../hackathonSchool/hackathonSchool';
import HackathonCollege from '../hackathonCollege/hackathonCollege';
import EnrollmentMenu from '../enrollment-menu/enrollmentMenu';
import MyJobs from '../myJobs/MyJobs';

function App() {
  console.log("configData.HACKATHON_DOMAIN ::: ", configData.HACKATHON_DOMAIN)
  const isHackathonDomain = window.location.hostname === configData.HACKATHON_DOMAIN;
  return (
    <div>
      <Routes>
      <Route
          path='/'
          element={
            isHackathonDomain ? (
              <HackathonHome />
            ) : (
              <BusinessChallenges />
            )
          }
        />
        <Route path='/school' element={<HackathonSchool />} />
        <Route path='/college' element={<HackathonCollege />} />
        <Route path='/enrollIndustry' element={<EnrollIndustry />} />
        <Route path='/enrollAcademicInst' element={<EnrollAcademicInst />} />
        <Route path='/enrollmentMenu' element={<EnrollmentMenu />}/>
        <Route element={<HackathonRoutes />}> 
        <Route path='/businesschallenges' element={<BusinessChallenges />} />
        <Route path='login' element={<Login />} />
        <Route path='changepassword' element={<ChangePassword />} />
        <Route path='forgotpassword' element={<Forgetpassword />} />
        <Route path='password/reset-password' element={<Resetpassword />} />
        <Route path='newenrollusers' element={<NewEnrollUser />} />
        <Route path='newenrollusersdetails' element={<NewEnrollUserDetail />} />
        <Route path='winnerslist' element={<WinnerView />} />
        <Route element={<PrivateRoutes />}>
          <Route path='terms' element={<Terms />} />
          <Route path='home' element={<Dashboard />} />
          <Route path='notifications' element={<Notification />} />
          <Route path='users' element={<User />} />
          <Route path='userdetails' element={<UserDetails />} />
          <Route path='industrypartner' element={<Company />} />
          <Route path='industrypartnerdetails' element={<CompanyDetails />} />
          <Route path='associatecollege' element={<College />} />
          <Route path='associatecollegedetails' element={<CollegeDetails />} />
          <Route path='industryverticals' element={<IndustryType />} />
          <Route path='industryverticaldetails' element={<IndustryTypeDetail />} />
          <Route path='participants' element={<Student />} />
          {/* <Route path='participantdetails' element={<StudentDetail />} /> */}
          <Route path='myindustryusecase' element={<MyChallenges />} />
          {/* <Route path='myJobs' element={<MyJobs />} /> */}
          <Route path='myindustryusecasedetails' element={<MyChallengesDetail />} />
          <Route path='industryusecase' element={<Challenges />} />
          <Route path='industryusecasedetails' element={<ChallengesDetail />} />
          <Route path='grovatorlab' element={<GrovatroLab />} />
          <Route path='grovatorlabdetails' element={<GrovatroLabDetail />} />
          <Route path='groupbycompany' element={<GroupByCompany />} />
          <Route path='groupbycollege' element={<GroupByCollege />} />
          <Route path='groupbychallenge' element={<GroupByChallenge />} />
          <Route path='usercasewinner' element={<WinnerAnnouncement />} />
          <Route path="*" element={<main style={{ padding: "1rem", color: "#058798" }}> <h3 className='text-center mt-4'>Still in development, will update soon...! </h3></main>} />
        </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
